module.exports = __webpack_public_path__ + "media/home3-left.aacb7ba1.mp4";